export const ACTION_CODE = 'ATTACHMENT_TYPE' + '_ACTION';
